import { render, staticRenderFns } from "./tickets-action.vue?vue&type=template&id=e696d2b4&"
import script from "./tickets-action.vue?vue&type=script&lang=js&"
export * from "./tickets-action.vue?vue&type=script&lang=js&"
import style0 from "./tickets-action.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports